import React, { ErrorInfo } from 'react';
import { Typography, Button, Container } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

interface Props { children: React.ReactNode; }
interface State { hasError: boolean; }

export class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_: Error): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("🚀 Orion Critical Error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Container sx={{
                    height: '100vh', display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center', textAlign: 'center',
                    bgcolor: '#f0f2f5'
                }}>
                    <ReportProblemIcon sx={{ fontSize: 80, color: '#5c7bb0', mb: 2 }} />
                    <Typography variant="h5" gutterBottom fontWeight="bold">
                        Системная ошибка Safari
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: '400px' }}>
                        Произошел сбой при записи данных в память iPhone. Мы подготовили систему к восстановлению.
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => {
                            if ('serviceWorker' in navigator) {
                                navigator.serviceWorker.getRegistrations().then(regs => {
                                    regs.forEach(r => r.unregister());
                                });
                            }
                            window.location.href = '/';
                        }}
                        sx={{ borderRadius: '20px', px: 4, bgcolor: '#5c7bb0' }}
                    >
                        Восстановить работу
                    </Button>
                </Container>
            );
        }
        return this.props.children;
    }
}

